import React, { useEffect, useState } from 'react';
import './styles.less';

import { useGlobal } from 'context';
import { GenericQuestionContainer } from '../components/GenericQuestionContainer';
import { QuestionContents } from '../components/QuestionContents';

export default function Question({
  question = {},
  answers = [],
  setAnswers = () => { },
  onBack = () => { },
  onNext = () => { },
  onDisqualified = () => { },
}) {
  const context = useGlobal();
  const [selected, setSelected] = useState([]);
  const [disqualified, setDisqualified] = useState(false);

  useEffect(() => {
    if (answers !== undefined && answers !== null) {
      setSelected(
        answers.filter((item) => item.id === question.id)[0]?.answer || []
      );
    }
  }, [question]);

  function updateQuestions() {
    let questionWithAnswer = question;
    questionWithAnswer.answer = selected;

    let prevAnswers = answers;
    answers = prevAnswers.filter((item) => item.id !== question.id);
    setAnswers([...answers, questionWithAnswer]);
    context.setLeadQuestions([...answers, questionWithAnswer]);
  }

  function handleBack() {
    updateQuestions();
    onBack();
  }

  function handleNext() {
    updateQuestions();
    if (
      question.disqualifying &&
      selected.some((e) => !question.positiveValues.includes(e))
    ) {
      setDisqualified(true);
      return;
    }

    onNext();
  }

  if (!question) {
    return <></>;
  }

  if (disqualified) {
    onDisqualified();
  }

  return (
    <GenericQuestionContainer
      onBack={handleBack}
      onNext={handleNext}
      disableNext={selected.length === 0 && question.skippable !== true}
      currentStep={question.stepNumber}
      totalSteps={10}
      whiteBackground
      sideImage={question.sideImage}
      bottomGraphic={question.bottomGraphic}
      questionTitle={question.content}
      footer={question.footer}
      decorationComponent={question.decoration}>
      <QuestionContents
        selected={selected}
        setSelected={setSelected}
        question={question}
      />
    </GenericQuestionContainer>
  );
}